import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Step,
  StepIconProps,
  StepLabel,
  Stepper,
  Switch,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import React, { useState, useEffect, useRef, useContext } from 'react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddIcon from '@mui/icons-material/Add';
import { Controller, FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { useLocation, useHistory, Prompt } from 'react-router-dom';
import KenLoader from '../../globalComponent/KenLoader';
import { useStyles } from '../../styles';
import { Box } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { DateCalendar, PickersDay } from '@mui/x-date-pickers';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CircleIcon from '@mui/icons-material/CircleOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { EventFormValues } from '../../utils/interfaces';
import { useAppFormContext } from '../../utils/formContext';
import { eventsCreation, getSessionDetails, updateSessionFee } from '../../utils/services';
import { getEventsData, postEventQuestionnaire } from '../../../../Utils/apiService';
import routes from '../../../../Utils/routes';
import { addNameSuffixToObject, convertArrayToText, generateUniqueKey, removeNullKeys } from '../../utils/helpers';
import KenTextField from '../../globalComponent/KenTextField';
import KenSelect from '../../globalComponent/KenSelect';
import { FormBuilder } from '../../globalComponent/FormBuilder';
import { formJsonStep1 } from '../../utils/formJson';
import { AppButton } from '../../globalComponent/AppButton';
import KenColors from '../../utils/kenColors';
import Sessions from './Sessions';
import { AuthContext } from '../../../../Helpers/Contexts/authContext';

import { createSurveyJson } from '../../../../Utils/FormJsons/createSurveyForm';
import CloseIcon from '@mui/icons-material/Close';
import FeedBackForm from './FeedBackForm';
const steps = ['Event setup', 'Date selection', 'Schedule setup', 'Fee setup', 'Feedback form'];
const questionTypes = [
  {
    label: 'Multile choice',
    value: 'multipleChoice',
  },
  {
    label: 'Checkbox',
    value: 'checkbox',
  },
  {
    label: 'Short Answer',
    value: 'shortAnswer',
  },
  {
    label: 'Linear Scale',
    value: 'linearScale',
  },
];

const HostEvent: React.FunctionComponent = () => {
  const classes = useStyles();
  const navigate = useHistory();
  const ismobile = useMediaQuery('(max-width: 600px)');
  const method = useForm<EventFormValues>({
    mode: 'onChange',
  });
  const method2 = useForm<any>({
    mode: 'onChange',
  });
  const {
    handleSubmit,
    reset,
    getValues,
    watch,
    formState: { dirtyFields, isDirty },
  } = method;
  const {
    state: { files },
    dispatch,
  } = useAppFormContext();
  const { control: controlTrigger, register: registerTrigger, watch: watchTrigger } = method2;
  const { enqueueSnackbar } = useSnackbar();
  const {
    state: { user },
  } = useContext(AuthContext);

  const { pathname, search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const eventId = searchParams.get('eventId');
  const isWithing1400 = useMediaQuery('(max-width:1440px)');
  const [loading, setLoading] = useState<boolean>(false);
  const [activeStep, SetActiveStep] = useState<number>(0);
  const [selectedDates, setSelectedDates] = useState<Array<string>>([]);
  const [selectedDate, setSelectedDate] = useState<any>({});
  const [sessionDetailsData, setSessionDetailsData] = useState<any>({});
  const [speakerDetailsData, setSpeakerDetailsData] = useState<any[]>([]);
  const [sessionDate, setSessionDate] = useState<string>('');
  const [feeType, setFeeType] = useState<string>('');
  const [feeTypeModal, setFeeTypemodal] = useState<boolean>(false);
  const [triggerFeedbackForm, setTriggerFeedbackForm] = useState<boolean>(false);
  const [feeSummary, setFeeSummary] = useState<boolean>(false);
  const [formTrigger, setFormTrigger] = useState<number>(0);
  const [currentFormStep, setCurrentFormStep] = useState<number>(0);
  const [totalFee, setTotalFee] = useState<number>(0);
  const [amount, setAmount] = useState('');
  const [isFree, setIsFree] = useState(false);
  const [questionCount, setQuestionCount] = useState<any[]>([
    {
      type: '',
      question: '',
      options: [{}],
    },
  ]);

  useEffect(() => {
    if (isFree) {
      setAmount('');
    }
  }, [isFree]);

  // Add debugging to watch form value changes
  useEffect(() => {
    console.log('Form values changed:', getValues());
    console.log('Form dirty state:', isDirty);
  }, [getValues, isDirty]);

  // Watch specific form fields to see if they're being updated
  const watchedValues = watch();
  console.log('Watched form values:', watchedValues);
  
  // Watch cover image specifically
  const watchedCoverImage = watch('coverImage');
  console.log('Watched cover image:', watchedCoverImage);

  const handleCheckBox = () => {
    setIsFree(!isFree);
  };

  const handleFeeSummary = () => {
    setFeeSummary(!feeSummary);
  };

  const handleFormTrigger = () => {
    console.log('Form trigger called, current formTrigger:', formTrigger);
    // Prevent multiple form triggers
    if (loading) {
      console.log('Form trigger blocked - loading in progress');
      return;
    }
    setFormTrigger((prev) => {
      const newValue = prev + 1;
      console.log('Form trigger updated to:', newValue);
      return newValue;
    });
  };

  const handleTriggerFeedbackForm = () => {
    setTriggerFeedbackForm(!triggerFeedbackForm);
  };

  const handleFeeTypeModal = () => {
    setFeeTypemodal(!feeTypeModal);
  };

  const handleNextStepper = () => {
    console.log('Moving from step', activeStep, 'to step', activeStep + 1);
    // Prevent multiple step navigation calls
    if (loading) {
      console.log('Step navigation blocked - loading in progress');
      return;
    }
    SetActiveStep((prevActiveStep) => {
      const nextStep = prevActiveStep + 1;
      console.log('Step updated to:', nextStep);
      return nextStep;
    });
  };

  const handleCancel: () => void = () => {
    SetActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleChangeDate = (date: string) => {
    setSessionDate(date);
  };

  function generateDatesBetween(startDate: string, endDate: string) {
    const dates = [];
    let current = moment(startDate);

    while (current.isSameOrBefore(moment(endDate), 'day')) {
      dates.push(current.format('YYYY-MM-DD'));
      current.add(1, 'day');
    }

    return dates;
  }

  const handleDateChange = (date: string) => {
    const formattedDate = moment(date).startOf('date').format('YYYY-MM-DD');

    if (selectedDates.includes(formattedDate)) {
      const updatedDates = [...selectedDates].sort((a, b) => moment(a).diff(moment(b)));

      const firstDate = moment(updatedDates[0]);
      const lastDate = moment(updatedDates[updatedDates.length - 1]);

      if (formattedDate === firstDate.format('YYYY-MM-DD') || formattedDate === lastDate.format('YYYY-MM-DD')) {
        setSelectedDates(updatedDates.filter((d) => d !== formattedDate));
      } else {
        const clickedDate = moment(formattedDate);
        if (clickedDate.diff(firstDate) < lastDate.diff(clickedDate)) {
          const newRange = updatedDates.filter((d) => moment(d).isSameOrAfter(clickedDate));
          setSelectedDates(newRange);
        } else {
          const newRange = updatedDates.filter((d) => moment(d).isSameOrBefore(clickedDate));
          setSelectedDates(newRange);
        }
      }
    } else {
      const updatedDates = [...selectedDates, formattedDate].sort((a, b) => moment(a).diff(moment(b)));
      const start = moment(updatedDates[0]);
      const end = moment(updatedDates[updatedDates.length - 1]);
      const dateRange = [];
      let currentDate = start;
      while (currentDate.isSameOrBefore(end)) {
        dateRange.push(currentDate.format('YYYY-MM-DD'));
        currentDate = currentDate.add(1, 'days');
      }
      setSelectedDates(dateRange);
    }
  };

  const isDateSelected = (date: string) => {
    const formattedDate = moment(date).startOf('date').format('YYYY-MM-DD');
    return selectedDates.includes(formattedDate);
  };

  const handleCurrentStepUpdate = (payload: any) => {
    // Fix: Ensure currentStep is always incremented correctly
    const nextStep = activeStep + 1;
    payload['currentStep'] = nextStep;
    console.log('Updating currentStep to:', nextStep, 'from activeStep:', activeStep);
    
    // Add a timestamp to prevent duplicate processing
    payload['_timestamp'] = Date.now();
    
    return payload;
  };

  console.log(activeStep, 'i5yu845y45y');

  const createEvent: SubmitHandler<EventFormValues> = async (data: EventFormValues) => {
    // Prevent multiple submissions
    if (loading) {
      console.log('Form submission already in progress, ignoring duplicate call');
      return;
    }
    
    let payload: any = { id: eventId, contactId: user?.applicantId };

    if (activeStep === 0) {
      payload = { ...payload };

      for (const keys in dirtyFields) {
        payload[keys] = (data as any)[keys];
      }

      if (
        Object.values(dirtyFields).every((items) => {
          return items === false;
        })
      ) {
        handleNextStepper();
        return;
      }

      // Handle file uploads properly - use the form values directly
      // The form values now contain the correct structure with pure base64
      for (const key in files) {
        const fileData = files[key];
        if (fileData && fileData?.data) {
          // Use the form values which already have the correct structure
          const formValue = (data as any)[key];
          if (formValue && formValue.imageUrl && formValue.fileName) {
            payload[key] = {
              imageUrl: formValue.imageUrl, // This is already pure base64
              fileName: formValue.fileName,
            };
          }
        }
      }

      // Multitext
      for (const key in payload) {
        if (key === 'suitablefor' || key === 'languageOfDelivery' || key === 'category' || key === 'timezone') {
          if (payload[key]) {
            payload[key] = convertArrayToText(payload[key]);
          }
        }
      }
    }

    if (activeStep === 1) {
      if (selectedDates.length === 0) {
        return enqueueSnackbar('Please select a start date or end date!', { variant: 'error' });
      }
      payload['startDate'] = selectedDates[0];
      payload['endDate'] = selectedDates[selectedDates.length - 1];
      payload['startTime'] = '00:00';
      payload['endTime'] = '00:00';
    }

    if (activeStep === 2) {
      const keys = Object.keys(sessionDetailsData);

      let hasSessionData: any = {};
      for (let i = 0; i < keys.length; i++) {
        const date = keys[i];
        const sessions = sessionDetailsData[date].sessions;

        for (let j = 0; j < sessions.length; j++) {
          const sessionData = sessions[j];

          if (hasSessionData.hasOwnProperty(date)) {
            if (sessionData.Id) {
              hasSessionData[date].push(sessionData);
            }
          } else {
            if (sessionData.Id) {
              hasSessionData[date] = [sessionData];
            } else {
              hasSessionData[date] = [];
            }
          }
        }
      }
      const hasSomeEmptySessions = Object.values(hasSessionData).some((items: any) => {
        return items.length === 0;
      });
      const emptyKeys = Object.keys(hasSessionData).filter((key) => Array.isArray(hasSessionData[key]) && hasSessionData[key].length === 0);
      let emptyKeysString;
      for (let i = 0; i < emptyKeys.length; i++) {
        const element = emptyKeys[i];
        if (i === emptyKeys.length - 1) {
          emptyKeysString = emptyKeysString + element;
        } else {
          if (emptyKeysString) {
            emptyKeysString = emptyKeysString + `${element}, `;
          } else {
            emptyKeysString = `${element}, `;
          }
        }
      }
      if (hasSomeEmptySessions) {
        setSessionDate(emptyKeys[0]);
        return enqueueSnackbar(`${emptyKeysString} have empty sessions, Please fill it!`, { variant: 'error' });
      }

      // if (feeType && feeType !== '') {
      //   handleNextStepper();
      //   return;
      // }

      handleFeeTypeModal();
      return;
    }

    if (activeStep === 3) {
      setLoading(true);
      const feePayload: Array<any> = [];
      let totalSuccess: Array<any> = [];

      if (feeType === 'Session-wise Pricing') {
        Object.keys(sessionDetailsData).forEach((dates: any) => {
          (sessionDetailsData[dates]?.feeType || [])
            .filter((items: any) => {
              return !items.id.includes('main');
            })
            .forEach((fee: any) => {
              const sessionData = sessionDetailsData[dates]?.sessions.find((items: any) => {
                return items.id === fee.id;
              });
              feePayload.push({
                sessionId: fee.id,
                sessionFee: !fee?.fee || fee?.fee === '' ? 0 : parseInt(fee?.fee),
                noFee: fee?.isFree,
                startTime: sessionData.startDate,
                endTime: sessionData.endDate,
                startDate: sessionData.startTime,
                endDate: sessionData.endTime,
              });
            });
        });
      } else {
        const totalSessions = Object.keys(sessionDetailsData).flatMap((items) => {
          return sessionDetailsData[items].sessions;
        });
        Object.keys(sessionDetailsData).forEach((dates: any) => {
          sessionDetailsData[dates].sessions.forEach((session: any) => {
            if (session?.id) {
              feePayload.push({
                sessionId: session.id,
                sessionFee: isFree ? 0 : parseInt(amount) / totalSessions.length,
                noFee: isFree,
                startTime: session.startDate,
                endTime: session.endDate,
                startDate: session.startTime,
                endDate: session.endTime,
              });
            }
          });
        });
      }

      for (let i = 0; i < feePayload.length; i++) {
        const sessionPayload = feePayload[i];
        await updateSessionFee(sessionPayload)
          .then((res: any) => {
            totalSuccess.push({ message: res?.data || '', status: true });
          })
          .catch((err) => {
            totalSuccess.push({ message: err.message, status: false });
          });
      }

      // Calculate total fee for eventFee
      let eventFeeValue = 0;
      if (feeType === 'Session-wise Pricing') {
        eventFeeValue = feePayload.reduce((sum, fee) => sum + (fee.sessionFee || 0), 0);
      } else {
        eventFeeValue = isFree ? 0 : parseInt(amount) || 0;
      }

      let eventNoFeeValue: any = '';
      if (feeType === 'Session-wise Pricing') {
        eventNoFeeValue = feePayload.some((fee) => fee.noFee) ? true : false;
      } else {
        eventNoFeeValue = isFree;
      }

      const newPayload = handleCurrentStepUpdate(
        removeNullKeys({
          ...payload,
          eventPricingType: feeType,
          eventFee: eventFeeValue,
          eventNoFee: feeType === 'Session-wise Pricing' ? null : eventNoFeeValue,
        })
      );
      await eventsCreation(newPayload);
      setLoading(false);
      const totalSuccessCount = totalSuccess.filter((items) => {
        return items?.status;
      });
      handleNextStepper();
      // Fix: Show appropriate message based on success count
      if (totalSuccessCount.length === feePayload.length) {
        enqueueSnackbar('Fees updated successfully', { variant: 'success' });
      } else {
        const failedCount = feePayload.length - totalSuccessCount.length;
        enqueueSnackbar(`${failedCount} fee updates failed. Please try again.`, { variant: 'warning' });
      }
      return;
    }

    if (activeStep === 4) {
      // Logic for feedback step
      navigate.push(routes.events);
      return;
    }

    // Main Call
    setLoading(true);
    console.log('Submitting payload:', handleCurrentStepUpdate(removeNullKeys(payload)));
    
    eventsCreation(handleCurrentStepUpdate(removeNullKeys(payload)))
      .then((res) => {
        setLoading(false);
        console.log('API Response:', res);
        
        // Fix: Check the correct response structure based on the API response
        if (res?.result?.success === true || res?.success === 'true' || res?.status === 'true') {
          console.log('API call successful, moving to next step');
          if (activeStep === 0 && !eventId) {
            // For new events, navigate to the event with the new eventId
            const newEventId = res.data?.data?.eventId || res.result?.data?.eventId;
            console.log('New event created with ID:', newEventId);
            navigate.push(`${routes.hostEvent}?eventId=${newEventId}`);
            handleNextStepper();
            dispatch({ type: 'removeFiles', value: { fieldName: 'coverImage' } });
          } else {
            // For existing events, update form and move to next step
            console.log('Existing event updated, moving to step:', activeStep + 1);
            // Use setTimeout to ensure state updates are processed correctly
            setTimeout(() => {
              handleFormTrigger();
              handleNextStepper();
              // Show success message
              enqueueSnackbar('Event updated successfully', { variant: 'success' });
            }, 100);
          }
        } else {
          // Check for error messages in the response
          console.log('API call failed:', res);
          const errorMessage = res?.result?.errorMessage || 
                              res?.result?.errorMessages?.[0]?.errorMessage || 
                              res?.response?.data?.errorMessage || 
                              res?.message || 
                              'Something went wrong';
          return enqueueSnackbar(errorMessage, { variant: 'error' });
        }
      })
      .catch((errmsg) => {
        setLoading(false);
        console.error('API call error:', errmsg);
        const err = errmsg?.response?.data?.errorMessage || errmsg?.message || 'Something went wrong';
        return enqueueSnackbar(err, { variant: 'error' });
      });
  };

  useEffect(() => {
    if (activeStep === 3) {
      const keys = Object.keys(sessionDetailsData);
      let total: number = 0;
      for (let i = 0; i < keys.length; i++) {
        const element = sessionDetailsData[keys[i]];
        if (element?.feeType) {
          const feeArray = element?.feeType;
          const mainFee = feeArray.find((fee: any) => fee.id.includes('main'));
          if (mainFee && mainFee.fee !== '') {
            total = parseInt(mainFee.fee);
            break;
          } else {
            for (let j = 0; j < feeArray.length; j++) {
              const fee = feeArray[j];
              if (fee?.fee !== '') {
                total = total + parseInt(fee?.fee);
              }
            }
          }
        }
      }
      setTotalFee(total);
    }
  }, [sessionDetailsData]);

  useEffect(() => {
    if (eventId) {
      setLoading(true);
      getEventsData()
        .then(async (res) => {
          // Fix: Handle the correct API response structure
          // The API returns: { status: "true", result: "[{...}, {...}]" }
          if (res.status === 'true' && res?.result && typeof res.result === 'string') {
            try {
              const eventData = JSON.parse(res.result)?.find((items: any) => {
                return items.Id === eventId;
              });
              console.log('Parsed event data:', JSON.parse(res.result), 'eventDataeventDataeventDataeventData');

              if (eventData) {
                console.log('Raw event data from API:', eventData);
                console.log('Event title from API:', eventData?.eventTitle);
                console.log('Category from API:', eventData?.category);
                console.log('Description from API:', eventData?.description);
                console.log('Cover image from API:', eventData?.coverImage);
                console.log('Suitable for from API:', eventData?.suitablefor);
                console.log('Language from API:', eventData?.languageOfDelivery);
                
                const eventStartTime = eventData?.startDate;
                const eventEndTime = eventData?.endDate;

                if (eventStartTime && eventEndTime) {
                  setSelectedDates(generateDatesBetween(eventStartTime, eventEndTime));
                }
              }

              // Move these variable declarations outside the if block so they can be accessed by session handling
              const eventPricingType = eventData?.eventPricingType;
              const formData = eventData ? {
                // Map to exact field names expected by FormBuilder
                eventTitle: eventData?.eventTitle, // Form expects 'eventTitle'
                category: [eventData?.category], // Form expects 'category' as array for dropdown
                maximumNumberofParticipants: eventData?.maximumNumberofParticipants, // Form expects 'maximumNumberofParticipants'
                description: eventData?.description || '', // Form expects 'description'
                agenda: eventData?.agenda || '', // Form expects 'agenda'
                coverImage: eventData?.coverImage || null, // Form expects 'coverImage' - pass API data directly
                suitablefor: [eventData?.suitablefor], // Form expects 'suitablefor' as array for dropdown
                languageOfDelivery: [eventData?.languageOfDelivery], // Form expects 'languageOfDelivery' as array for dropdown
                eventBroucher: eventData?.eventBroucher || null, // Form expects 'eventBroucher'
                timezone: [eventData?.timezone], // Form expects 'timezone' as array for dropdown
                targetKeywords: eventData?.targetKeyWords || '', // Form expects 'targetKeywords'
              } : {};
              
              let newFormData = { ...getValues(), ...formData };
              console.log('Combined form data:', newFormData);
              
              // Only reset form if we have event data
              if (eventData) {
                // Debug: Check what's in the form before reset
                console.log('Form values before reset:', getValues() as any);
                
                // Reset the form with the new data
                console.log('About to reset form with data:', newFormData);
                reset(newFormData as any);
                console.log('Form reset completed');
                
                // Debug: Check what's in the form after reset (immediately, no setTimeout)
                const formValues = getValues() as any;
                console.log('Form values after reset:', formValues);
                console.log('Form dirty state after reset:', isDirty);
                
                // Check if specific fields are set
                console.log('Event title value:', formValues.eventTitle);
                console.log('Category value:', formValues.category);
                console.log('Description value:', formValues.description);
                console.log('Cover image value:', formValues.coverImage);
                console.log('Suitable for value:', formValues.suitablefor);
                console.log('Language value:', formValues.languageOfDelivery);
                console.log('Timezone value:', formValues.timezone);
                
                // Debug: Check the raw form data being set
                console.log('Raw form data being set:', formData);
                console.log('Category from API:', eventData?.category);
                console.log('Suitable for from API:', eventData?.suitablefor);
                console.log('Language from API:', eventData?.languageOfDelivery);
                console.log('Timezone from API:', eventData?.timezone);
                console.log('Cover image from API:', eventData?.coverImage);
                console.log('Cover image structure being set:', formData.coverImage);
                
                // Debug: Check if the form values are actually being set
                console.log('Form values after reset (detailed):', {
                  eventTitle: formValues.eventTitle,
                  category: formValues.category,
                  suitablefor: formValues.suitablefor,
                  languageOfDelivery: formValues.languageOfDelivery,
                  timezone: formValues.timezone,
                  description: formValues.description,
                  agenda: formValues.agenda,
                  coverImage: formValues.coverImage
                });
              }

              let customsession: any = {};
              let dateDatas: any = {};

              const sessionRes = await getSessionDetails(eventId);
              console.log(JSON.parse(sessionRes.result)?.sessions, 'sessionRes12343212321');

              if (sessionRes?.status === 'true') {
                const session = sessionRes.result && typeof sessionRes.result === 'string' ? JSON.parse(sessionRes.result)?.sessions : [];
                const contacts = sessionRes.result && typeof sessionRes.result === 'string' ? JSON.parse(sessionRes.result)?.contacts : [];
                let totalAmoutForWholeEvent = 0;

                for (let i = 0; i < session.length; i++) {
                  const element = session[i];
                  if (element.Session_Fee__c) {
                    totalAmoutForWholeEvent = totalAmoutForWholeEvent + element.Session_Fee__c;
                  }
                }

                session.forEach((items: any, mainIndex: number) => {
                  const sessionSpeakers =
                    items?.Event_Session_Account_Associations__r?.records?.map((speaker: any, index: number) => {
                      const uniqueKey = generateUniqueKey();
                      let nameSuffix = `${items?.Start_Date__c}-${uniqueKey}`;
                      return {
                        Id: speaker?.Id,
                        speakerId: uniqueKey,
                        [`speakerName-${nameSuffix}`]: speaker?.Contact__c,
                        [`descriptionAboutTheSpeaker-${nameSuffix}`]: speaker?.Description__c,
                        [`speakerImage-${nameSuffix}`]: speaker?.Speaker_Image__c,
                      };
                    }) || [];
                  const uniqueKey = generateUniqueKey();
                  let customSession = {
                    ...items,
                    sessionTitle: items?.Name,
                    startTime: items?.Start_Date__c,
                    endTime: items?.End_Date__c,
                    startDate: items?.Start_Time__c,
                    endDate: items?.End_Time__c,
                    sessionBroucher: items?.Session_Broucher__c,
                    sessionAgenda: items?.What_to_Expect_From_Event__c,
                    locationType: items?.Location_Type__c,
                    sessionLink: items?.Session_Link__c,
                    locationAddress: items?.Location__c,
                    id: items?.Id,
                    sessionId: uniqueKey,
                    speakers: sessionSpeakers.length > 0 ? [...sessionSpeakers] : [{}],
                    timezone: items?.Timezone__c,
                  };

                  if (Object(customsession).hasOwnProperty(items?.Start_Date__c)) {
                    customsession[items?.Start_Date__c]['sessions'].push(customSession);
                  } else {
                    customsession[items?.Start_Date__c] = {
                      sessions: [{ ...customSession }],
                    };
                  }

                  if (eventPricingType) {
                    const setPricingType = feeType ? feeType : eventPricingType;
                    if (setPricingType === 'Session-wise Pricing') {
                      if (Object(customsession).hasOwnProperty(items?.Start_Date__c)) {
                        if (Object(customsession[items?.Start_Date__c]).hasOwnProperty('feeType')) {
                          customsession[items?.Start_Date__c]['feeType'].push({ id: items?.Id, fee: items?.Session_Fee__c || 0, isFree: items?.Session_Fee__c ? items?.No_Fee__c : true });
                        } else {
                          customsession[items?.Start_Date__c] = {
                            ...customsession[items?.Start_Date__c],
                            feeType: [{ id: items?.Id, fee: items?.Session_Fee__c || 0, isFree: items?.Session_Fee__c ? items?.No_Fee__c : true }],
                          };
                        }
                      }
                    } else {
                      setAmount(`${totalAmoutForWholeEvent}`);
                      setIsFree(totalAmoutForWholeEvent === 0);
                    }
                  }
                });

                selectedDates.forEach((items: string) => {
                  dateDatas[items] = {};

                  if (!customsession.hasOwnProperty(items)) {
                    customsession[items] = {
                      sessions: [
                        {
                          edit: true,
                          sessionId: generateUniqueKey(),
                          speakers: [
                            {
                              speakerId: generateUniqueKey(),
                              edit: true,
                            },
                          ],
                        },
                      ],
                    };
                  }
                });

                const forms = Object.keys(customsession);
                for (let i = 0; i < forms.length; i++) {
                  const element: any = forms[i];
                  const sessionDetails = customsession[element];
                  const sessions = sessionDetails.sessions;
                  for (let j = 0; j < sessions.length; j++) {
                    const sessionElements = sessions[j];
                    const sessionIdAdd = `${element}-${sessionElements?.sessionId}`;
                    if (sessionElements?.sessionId) {
                      dispatch({
                        type: 'updateTimeRange',
                        value: {
                          fieldName: `sessionTimeRange-${sessionIdAdd}`,
                          fileData: {
                            startTime: moment(sessionElements?.Start_Time__c, 'HH:mm:ss.SSSZ').utc().format('HH:mm'),
                            endTime: moment(sessionElements?.End_Time__c, 'HH:mm:ss.SSSZ').utc().format('HH:mm'),
                          },
                        },
                      });
                      if (sessionElements?.sessionBroucher) {
                        dispatch({
                          type: 'updateFiles',
                          value: {
                            fieldName: `sessionBroucher-${sessionIdAdd}`,
                            fileData: {
                              data: sessionElements?.sessionBroucher,
                              name: 'Sample.jpg',
                            },
                          },
                        });
                      }
                      newFormData = {
                        ...newFormData,
                        ...addNameSuffixToObject(sessionElements, sessionIdAdd),
                        [`sessionTimeRange-${sessionIdAdd}`]: {
                          startTime: moment(sessionElements?.Start_Time__c, 'HH:mm:ss.SSSZ').utc().format('HH:mm'),
                          endTime: moment(sessionElements?.End_Time__c, 'HH:mm:ss.SSSZ').utc().format('HH:mm'),
                        },
                      };
                      const speakersElement = sessionElements?.speakers;
                      for (let k = 0; k < speakersElement.length; k++) {
                        const speakerRecord = speakersElement[k];
                        const speakerIdAdd = `${element}-${speakerRecord?.speakerId}`;
                        if (speakerRecord[`speakerImage-${speakerIdAdd}`]) {
                          dispatch({
                            type: 'updateFiles',
                            value: {
                              fieldName: `speakerImage-${speakerIdAdd}`,
                              fileData: {
                                data: speakerRecord[`speakerImage-${speakerIdAdd}`],
                                name: 'Sample.jpg',
                              },
                            },
                          });
                        }
                        newFormData = {
                          ...newFormData,
                          ...speakerRecord,
                        };
                      }
                    }
                  }
                }

                dispatch({
                  type: 'updateOptions',
                  value: {
                    fieldName: 'contacts',
                    selectOptions: contacts.map((items: any) => {
                      return { value: items?.Id, label: items?.FirstName ? items?.FirstName : items?.LastName };
                    }),
                  },
                });
              }

              setSpeakerDetailsData(customsession);
              setFeeType(feeType ? feeType : eventPricingType);
              setSessionDetailsData(customsession);
              setSelectedDate(dateDatas);
              setSessionDate(selectedDates[0]);
              setLoading(false);
            } catch (error) {
              console.error('Error parsing host event data:', error);
              setLoading(false);
            }
          } else {
            setLoading(false);
          }
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    }
  }, [eventId, formTrigger, activeStep]);

  useEffect(() => {
    if (eventId) {
      getEventsData()
        .then((res) => {
          // Fix: Handle the correct API response structure
          // The API returns: { status: "true", result: "[{...}, {...}]" }
          if (res.status === 'true' && res?.result && typeof res.result === 'string') {
            try {
              const eventData = JSON.parse(res.result)?.find((items: any) => {
                return items.Id === eventId;
              });
              console.log('Step navigation event data:', eventData, 'eventDataeventDataeventData');

              if (eventData) {
                const formCurrentStep = eventData?.currentStep;
                // Fix: Only set activeStep if we're not in the middle of form submission
                // This prevents overriding the step navigation after saving
                if (formTrigger === 0) {
                  console.log('Setting activeStep to:', formCurrentStep, 'from event data');
                  SetActiveStep(formCurrentStep);
                  setCurrentFormStep(formCurrentStep);
                } else {
                  console.log('Form submission in progress, not overriding activeStep');
                }
              }
            } catch (error) {
              console.error('Error parsing event data for step navigation:', error);
            }
          } else {
            console.log('Invalid API response structure for step navigation:', res);
          }
        })
        .catch((err) => {
          console.error('Error fetching event data for step navigation:', err);
        });
    }
  }, [formTrigger, eventId]);

  window.addEventListener('popstate', () => {
    dispatch({ type: 'removeFiles', value: { fieldName: 'coverImage' } });
  });

  function ServerDay(props: any) {
    const { day, outsideCurrentMonth, selected, ...other } = props;
    const past = moment().format('YYYY-MM-DD') > moment(day).format('YYYY-MM-DD') || moment(day).format('YYYY-MM-DD') > moment().add(90, 'days').format('YYYY-MM-DD');
    const isSelected = isDateSelected(moment(day).format());

    return (
      <PickersDay
        sx={{
          fontSize: '14px',
          fontWeight: '400',
          background: isSelected ? KenColors.ClientBlue3 : 'transparent',
          color: isSelected ? KenColors.kenWhite : KenColors.ClientBlack2,
          ':disabled': {
            background: past ? 'transparent' : KenColors.ClientDisabledGrey,
            color: past ? KenColors.ClientDateGrey : KenColors.CalendarDate,
          },
          ':hover': {
            background: isSelected ? KenColors.ClientBlue3 : 'transparent',
            color: isSelected ? KenColors.kenWhite : KenColors.ClientBlack2,
          },
          ':focus': {
            background: KenColors.ClientBlue3,
            color: KenColors.kenWhite,
          },
        }}
        {...other}
        outsideCurrentMonth={outsideCurrentMonth}
        day={day}
        disabled={past}
      />
    );
  }
  const submitRequest = () => {
    enqueueSnackbar({
      message: 'Event request submitted successfully',
      variant: 'success',
      autoHideDuration: 1000,
    });
    navigate.push('/events/created-events?tab=inreview');
  };
  const StepperContent = (activeStep: number) => {
    switch (activeStep) {
      case 0:
        return <FormBuilder formJson={formJsonStep1} />;
      case 1:
        return (
          <FormProvider {...method}>
            <Paper className={`${classes.cardContainerForm} scrollbar-cus`} sx={{ background: KenColors.ClientGrey2, margin: '20px 0px' }}>
              <Grid container spacing={4}>
                <Grid item lg={6}>
                  {/* <StaticDa */}
                  <DateCalendar
                    slots={{
                      day: ServerDay,
                    }}
                    onChange={handleDateChange}
                    minDate={moment().startOf('date') as any}
                    classes={{ root: classes.rootClasses }}
                    sx={{
                      // '& .MuiDayCalendar-monthContainer': {
                      //   height: '300px !important',
                      // },
                      height: '375px !important',
                      maxHeight: '375px !important',
                    }}
                  />
                </Grid>
                <Grid item lg={6} margin={'auto 0px'}>
                  <Box component={'div'} gap={'36px'} className="d-flex flex-column">
                    <Box component={'div'} className="d-flex flex-column" gap={'12px'}>
                      <Typography color={KenColors.ClientBlack2} fontSize={'14px'} fontWeight={'500'}>
                        Please select your preferred dates for the event:
                      </Typography>
                      <Box component={'div'} className="d-flex flex-column" gap={'4px'}>
                        <Typography color={KenColors.ClientBlack2} fontSize={'14px'} fontWeight={'400'}>
                          Choose one date if it is a single-day event.
                        </Typography>
                        <Typography color={KenColors.ClientBlack2} fontSize={'14px'} fontWeight={'400'}>
                          Choose multiple dates if it is a multi-day event.
                        </Typography>
                      </Box>
                    </Box>
                    <Box component={'div'} className="d-flex flex-column" gap={'12px'}>
                      <Typography color={KenColors.ClientBlack2} fontSize={'14px'} fontWeight={'500'}>
                        Dates selected
                      </Typography>
                      <Box component={'div'} className="d-flex flex-wrap align-items-center" gap={'8px'}>
                        {selectedDates.map((items) => {
                          return (
                            <Box
                              component={'div'}
                              sx={{
                                background: KenColors.ClientBlack1,
                                borderRadius: '20px',
                                padding: '6px 12px',
                              }}
                              key={items}
                              gap={'8px'}
                              className="d-flex align-items-center"
                            >
                              <Typography color={KenColors.kenWhite} fontSize={'12px'} fontWeight={'500'}>
                                {moment(items).format('DD MMM, YYYY')}
                              </Typography>
                              <IconButton
                                sx={{ padding: '0px' }}
                                onClick={() => {
                                  handleDateChange(items);
                                }}
                              >
                                <CloseRoundedIcon style={{ width: '16px', height: '16px', color: KenColors.kenWhite }} />
                              </IconButton>
                            </Box>
                          );
                        })}
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </FormProvider>
        );
      case 2:
        return (
          <FormProvider {...method}>
            <Sessions
              feeType={feeType}
              feeTypeModal={feeTypeModal}
              handleChangeDate={handleChangeDate}
              handleFeeTypeModal={handleFeeTypeModal}
              handleFormTrigger={handleFormTrigger}
              handleNextStepper={handleNextStepper}
              selectedDate={selectedDate}
              sessionDate={sessionDate}
              sessionDetailsData={sessionDetailsData}
              speakerDetailsData={speakerDetailsData}
              setFeeType={setFeeType}
              setSessionDetailsData={setSessionDetailsData}
            />
          </FormProvider>
        );
      case 3:
        return (
          <FormProvider {...method}>
            <>
              {feeType === 'Session-wise Pricing' ? (
                <Box component={'div'} padding={ismobile ? '0px' : '0px 140px'}>
                  <Box component={'div'} className="d-flex justify-content-between align-items-center" margin={'30px 0px'}>
                    <Typography color={KenColors.ClientBlack2} fontSize={'12px'} fontWeight={'500'}>
                      Day & session details
                    </Typography>
                    <Box component={'div'} className="d-flex align-items-start" gap={'144px'}>
                      <Typography color={KenColors.ClientBlack2} fontSize={'12px'} fontWeight={'500'}>
                        Setup price
                      </Typography>
                      <Typography color={KenColors.ClientBlack2} fontSize={'12px'} fontWeight={'500'}>
                        Mark as free
                      </Typography>
                    </Box>
                  </Box>
                  {Object.keys(sessionDetailsData).map((items: string, index: number) => {
                    const parentRecord = (sessionDetailsData[items]?.feeType || []).find((sessionItems: any) => {
                      return sessionItems.id === `main-${index + 1}`;
                    });

                    return (
                      <Box component={'div'} className="d-flex flex-column" gap={'36px'} key={index}>
                        <Box component={'div'} className="d-flex justify-content-between align-items-center">
                          <Typography color={KenColors.ClientBlack2} fontSize={'18px'} fontWeight={'500'}>
                            {moment(items).format('DD MMM YYYY')}
                          </Typography>
                          <Box component={'div'} className="d-flex align-items-center" gap={'60px'}>
                            <KenTextField
                              placeholder="--"
                              size="small"
                              value={parentRecord?.fee || ''}
                              type="text" // Change to text to prevent symbols
                              inputMode="numeric" // Ensures numeric keyboard on mobile
                              disabled={parentRecord ? parentRecord?.isFree : false}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <CurrencyRupeeIcon />
                                  </InputAdornment>
                                ),
                              }}
                              onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                                // Allow only 0-9, Backspace, Delete, Arrow keys, and Tab
                                if (!/^[0-9]$/.test(e.key) && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // Remove non-numeric characters
                                const sanitizedValue = e.target.value.replace(/[^0-9]/g, '');
                                let customSessionDetails = { ...sessionDetailsData };

                                if (Object(customSessionDetails[items]).hasOwnProperty('feeType')) {
                                  const findExistRecord = customSessionDetails[items]['feeType'].find((items: any) => items.id === `main-${index + 1}`);
                                  if (findExistRecord) {
                                    customSessionDetails[items]['feeType'].forEach((items: any) => {
                                      if (items.id === `main-${index + 1}`) {
                                        items.fee = sanitizedValue;
                                      }
                                    });
                                  } else {
                                    customSessionDetails[items]['feeType'].push({ id: `main-${index + 1}`, fee: sanitizedValue, isFree: false });
                                  }
                                } else {
                                  customSessionDetails[items]['feeType'] = [{ id: `main-${index + 1}`, fee: sanitizedValue, isFree: false }];
                                }

                                (customSessionDetails[items]?.feeType || []).forEach((items: any) => {
                                  const isContainsMain = items.id?.includes('main');
                                  if (!isContainsMain) {
                                    items['fee'] = '';
                                    items['isFree'] = false;
                                  }
                                });

                                setSessionDetailsData(customSessionDetails);

                                // Split the amount to other fields
                                const totalSessions = sessionDetailsData[items].sessions.length;
                                const splitAmount = sanitizedValue ? (parseInt(sanitizedValue) / totalSessions).toFixed(2) : '';

                                sessionDetailsData[items].sessions.forEach((subItems: any, subIndex: number) => {
                                  const currentFee = sessionDetailsData[items]?.feeType?.find((feeItems: any) => {
                                    return feeItems.id === subItems.id;
                                  });

                                  if (currentFee) {
                                    currentFee.fee = splitAmount;
                                  } else {
                                    sessionDetailsData[items]['feeType'].push({ id: subItems.id, fee: splitAmount, isFree: false });
                                  }
                                });

                                console.log(sessionDetailsData, 'oi569uy956u');

                                setSessionDetailsData({ ...sessionDetailsData });
                              }}
                            />

                            <Checkbox
                              checked={parentRecord?.isFree || false}
                              disabled={parentRecord ? parentRecord?.fee !== '' : false}
                              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                let customSessionDetails = { ...sessionDetailsData };
                                if (Object(customSessionDetails[items]).hasOwnProperty('feeType')) {
                                  const findExistRecord = customSessionDetails[items]['feeType'].find((items: any) => {
                                    return items.id === `main-${index + 1}`;
                                  });
                                  if (findExistRecord) {
                                    customSessionDetails[items]['feeType'].forEach((fees: any) => {
                                      if (fees['id'] === `main-${index + 1}`) {
                                        if (fees['isFree']) {
                                          fees['isFree'] = false;
                                        } else {
                                          fees['isFree'] = true;
                                        }
                                      }
                                    });
                                  } else {
                                    customSessionDetails[items]['feeType'].push({ id: `main-${index + 1}`, fee: '', isFree: true });
                                  }
                                } else {
                                  customSessionDetails[items]['feeType'] = [{ id: `main-${index + 1}`, fee: '', isFree: true }];
                                }
                                setSessionDetailsData(customSessionDetails);
                              }}
                            />
                          </Box>
                        </Box>
                        {sessionDetailsData[items].sessions.map((subItems: any, subIndex: number) => {
                          const currentFee = sessionDetailsData[items]?.feeType?.find((feeItems: any) => {
                            return feeItems.id === subItems.id;
                          });

                          return (
                            Object.keys(subItems).length > 0 && (
                              <Box component={'div'} className="d-flex justify-content-between align-items-center">
                                <Box component={'div'} className="d-flex flex-column" gap={'2px'}>
                                  <Typography color={KenColors.CalendarDate} fontSize={'12px'} fontWeight={'400'}>
                                    Session {subIndex + 1}
                                  </Typography>
                                  <Typography color={KenColors.ClientBlack2} fontSize={'12px'} fontWeight={'500'}>
                                    {subItems?.sessionTitle}
                                  </Typography>
                                </Box>

                                <Box component={'div'} className="d-flex align-items-center" gap={'60px'}>
                                  <KenTextField
                                    placeholder="Enter amount"
                                    size="small"
                                    type="text" // Prevents invalid symbols like "--", "++", and "e"
                                    inputMode="numeric"
                                    value={currentFee?.fee || ''}
                                    disabled={parentRecord ? parentRecord?.fee !== '' || parentRecord?.isFree : currentFee ? currentFee?.isFree : false}
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <CurrencyRupeeIcon />
                                        </InputAdornment>
                                      ),
                                    }}
                                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                                      // Allow only numbers 0-9 and essential keys
                                      if (
                                        !/^[0-9]$/.test(e.key) && // Allow only numbers 0-9
                                        !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'].includes(e.key) // Allow navigation keys
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                      // Remove any non-numeric characters if pasted
                                      const sanitizedValue = e.target.value.replace(/[^0-9]/g, '');

                                      let customSessionDetails = { ...sessionDetailsData };
                                      if (Object(customSessionDetails[items]).hasOwnProperty('feeType')) {
                                        const findExistRecord = customSessionDetails[items]['feeType'].find((items: any) => {
                                          return items.id === subItems.id;
                                        });
                                        if (findExistRecord) {
                                          customSessionDetails[items]['feeType'].forEach((fees: any) => {
                                            if (fees['id'] === subItems.id) {
                                              fees['fee'] = sanitizedValue;
                                            }
                                          });
                                        } else {
                                          customSessionDetails[items]['feeType'].push({ id: subItems.id, fee: sanitizedValue, isFree: false });
                                        }
                                      } else {
                                        customSessionDetails[items]['feeType'] = [{ id: subItems.id, fee: sanitizedValue, isFree: false }];
                                      }
                                      setSessionDetailsData(customSessionDetails);
                                    }}
                                  />

                                  <Checkbox
                                    checked={currentFee?.isFree || false}
                                    disabled={parentRecord ? parentRecord?.fee !== '' || parentRecord?.isFree : false}
                                    onChange={() => {
                                      let customSessionDetails = { ...sessionDetailsData };
                                      if (Object(customSessionDetails[items]).hasOwnProperty('feeType')) {
                                        const findExistRecord = customSessionDetails[items]['feeType'].find((items: any) => {
                                          return items.id === subItems.id;
                                        });
                                        if (findExistRecord) {
                                          customSessionDetails[items]['feeType'].forEach((fees: any) => {
                                            if (fees['id'] === subItems.id) {
                                              if (fees['isFree']) {
                                                fees['isFree'] = false;
                                              } else {
                                                fees['isFree'] = true;
                                                fees['fee'] = '';
                                              }
                                            }
                                          });
                                        } else {
                                          customSessionDetails[items]['feeType'].push({ id: subItems.id, fee: '', isFree: true });
                                        }
                                      } else {
                                        customSessionDetails[items]['feeType'] = [{ id: subItems.id, fee: '', isFree: true }];
                                      }
                                      setSessionDetailsData(customSessionDetails);
                                    }}
                                  />
                                </Box>
                              </Box>
                            )
                          );
                        })}
                        <Divider sx={{ height: '2px', background: KenColors.ClientDivider, margin: '0px 0px 20px 0px' }} />
                      </Box>
                    );
                  })}
                  <Box component={'div'} className="d-flex justify-content-between align-items-center">
                    <Typography color={KenColors.ClientBlack2} fontSize={'12px'} fontWeight={'500'}>
                      Total event cost
                    </Typography>
                    <Box component={'div'} className="d-flex align-items-start" gap={'60px'}>
                      <KenTextField
                        placeholder="--"
                        size="small"
                        value={totalFee}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <CurrencyRupeeIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Checkbox sx={{ visibility: 'hidden' }} />
                    </Box>
                  </Box>
                </Box>
              ) : (
                <Box component={'div'} padding={'20px 140px'}>
                  <Box component={'div'} className="d-flex justify-content-between align-items-center" margin={'30px 0px'}>
                    <Typography color={KenColors.ClientBlack2} fontSize={'12px'} fontWeight={'500'}>
                      Event details
                    </Typography>
                    <Box component={'div'} className="d-flex align-items-start" gap={'144px'}>
                      <Typography color={KenColors.ClientBlack2} fontSize={'12px'} fontWeight={'500'}>
                        Setup price
                      </Typography>
                      <Typography color={KenColors.ClientBlack2} fontSize={'12px'} fontWeight={'500'}>
                        Mark as free
                      </Typography>
                    </Box>
                  </Box>
                  <Box component={'div'} className="d-flex justify-content-between align-items-center">
                    <Typography color={KenColors.ClientBlack2} fontSize={'18px'} fontWeight={'500'}>
                      A kickstart to your startup journey
                    </Typography>
                    <Box component={'div'} className="d-flex align-items-center" gap={'30px'}>
                      <KenTextField
                        placeholder="Enter amount"
                        size="small"
                        type="text" // Prevents invalid symbols like "--", "++", and "e"
                        inputMode="numeric" // Ensures numeric keypad on mobile
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <CurrencyRupeeIcon />
                            </InputAdornment>
                          ),
                        }}
                        value={amount}
                        onKeyDown={(e: { key: string; preventDefault: () => void }) => {
                          // Allow only numbers and essential keys
                          if (
                            !/^[0-9]$/.test(e.key) && // Only allow numbers 0-9
                            !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)
                          ) {
                            e.preventDefault();
                          }
                        }}
                        disabled={isFree}
                        onChange={(e: { target: { value: any } }) => {
                          // Ensure the value contains only numbers
                          const { value } = e.target;
                          e.target.value = value.replace(/[^0-9]/g, '');
                          setAmount(value);
                        }}
                      />

                      <Checkbox
                        checked={isFree}
                        onChange={() => {
                          handleCheckBox();
                        }}
                      />
                    </Box>
                  </Box>
                  <Box component={'div'} className="d-flex align-items-center" margin={'30px 0px'}>
                    <Typography
                      color={KenColors.ClientBlue7}
                      fontSize={'12px'}
                      fontWeight={'500'}
                      component={'h6'}
                      onClick={() => {
                        handleFeeSummary();
                      }}
                    >
                      {!feeSummary ? 'Show summary' : 'Hide summary'}
                    </Typography>
                    {feeSummary ? <KeyboardArrowUpIcon style={{ height: '18px', width: '18px' }} /> : <KeyboardArrowDownIcon style={{ height: '18px', width: '18px' }} />}
                  </Box>
                  {feeSummary && (
                    <Box component={'div'} className="d-flex flex-column" gap={'40px'}>
                      {Object.keys(sessionDetailsData).map((items: any) => {
                        return (
                          <Box component={'div'} className="d-flex flex-column" gap={'16px'} key={items}>
                            <Typography component={'div'} color={KenColors.ClientBlue7} fontSize={'12px'} fontWeight={'500'}>
                              {items}
                            </Typography>
                            <Box component={'div'} className="d-flex flex-column" gap={'16px'}>
                              {sessionDetailsData[items].sessions
                                .filter(
                                  (subItems: any) => subItems.speakers && subItems.speakers.some((speaker: any) => speaker.Id) // ✅ Only keep sessions where at least one speaker has an `Id`
                                )
                                .map((subItems: any, subIndex: number) => (
                                  <Box component={'div'} className="d-flex flex-column" gap={'8px'} key={subIndex}>
                                    <Typography color={KenColors.ClientBlack1} fontSize={'12px'} fontWeight={'400'}>
                                      {`Session ${subIndex + 1}`}
                                    </Typography>
                                    <Typography color={KenColors.ClientBlack1} fontSize={'12px'} fontWeight={'500'}>
                                      {subItems?.sessionTitle}
                                    </Typography>
                                  </Box>
                                ))}
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                  )}
                </Box>
              )}
            </>
          </FormProvider>
        );
      case 4:
        return (
          <FormProvider {...method}>
            <>
              <Dialog
                open={triggerFeedbackForm}
                onClose={() => {
                  handleTriggerFeedbackForm();
                }}
                sx={{
                  '& .MuiDialog-paper': {
                    borderRadius: '12px',
                    minWidth: ismobile ? '90vw' : '500px',
                    width: ismobile ? '90vw' : 'auto',
                    padding: ismobile ? '8px' : '0px',
                    margin: ismobile ? '0px' : undefined,
                  },
                }}
              >
                <Box
                  component={'div'}
                  className="d-flex flex-column justify-content-between"
                  gap={ismobile ? '24px' : '50px'}
                  padding={ismobile ? '12px' : '24px'}
                  minWidth={ismobile ? undefined : '500px'}
                  width={ismobile ? '100%' : undefined}
                >
                  <Box component={'div'} className="d-flex flex-column" gap={ismobile ? '16px' : '24px'}>
                    <Typography color={KenColors.ClientBlack2} fontSize={ismobile ? '16px' : '18px'} fontWeight={'500'}>
                      Triggering feedback form
                    </Typography>
                    <Box component={'div'} className="d-flex flex-column" gap={'8px'}>
                      <Typography color={KenColors.ClientBlack2} fontSize={'12px'} fontWeight={'500'}>
                        How would you like to trigger the form?
                      </Typography>
                      <Controller
                        control={controlTrigger}
                        render={({ field }) => {
                          return (
                            <RadioGroup {...field} row>
                              <FormControlLabel control={<Radio />} value={'autoTrigger'} label={'Auto-trigger'} />
                              <FormControlLabel control={<Radio />} value={'manualTrigger'} label={'Trigger manually after event'} />
                            </RadioGroup>
                          );
                        }}
                        {...registerTrigger('triggerMethod')}
                      />
                    </Box>
                    {watchTrigger('triggerMethod') && (
                      <>
                        {watchTrigger('triggerMethod') === 'autoTrigger' ? (
                          <Box component={'div'} className="d-flex flex-column" gap={'8px'}>
                            <Typography color={KenColors.ClientBlack2} fontSize={'12px'} fontWeight={'500'}>
                              When do you want to trigger ?
                            </Typography>
                            <KenSelect
                              options={[
                                {
                                  label: 'Immediately after the event',
                                  value: 'immediatelyAfterEvent',
                                },
                                {
                                  label: 'One hour after the event',
                                  value: 'oneHourAfterEvent',
                                },
                                {
                                  label: '24 hours after the event',
                                  value: '24HourAfterEvent',
                                },
                              ]}
                            />
                          </Box>
                        ) : (
                          <Box component={'div'} className="d-flex flex-column" gap={ismobile ? '16px' : '24px'}>
                            <Box component={'div'} className="d-flex flex-column" gap={'8px'}>
                              <Typography color={KenColors.ClientBlack2} fontSize={'12px'} fontWeight={'500'}>
                                Select date
                              </Typography>
                              <KenTextField type="date" />
                            </Box>
                            <Box component={'div'} className="d-flex flex-column" gap={'8px'}>
                              <Typography color={KenColors.ClientBlack2} fontSize={'12px'} fontWeight={'500'}>
                                Select time
                              </Typography>
                              <KenTextField type="time" />
                            </Box>
                          </Box>
                        )}
                      </>
                    )}
                  </Box>
                  <Box component={'div'} className="d-flex align-items-center" gap={'12px'}>
                    <AppButton
                      variant="text"
                      fullWidth
                      size="medium"
                      others={{
                        color: KenColors.ClientBlack2,
                      }}
                      onClick={() => {
                        handleTriggerFeedbackForm();
                      }}
                    >
                      Cancel
                    </AppButton>
                    <AppButton
                      variant="contained"
                      fullWidth
                      size="medium"
                      onClick={() => {
                        submitRequest();
                      }}
                    >
                      Submit request
                    </AppButton>
                  </Box>
                </Box>
              </Dialog>
              <Grid>
                <FeedBackForm />
              </Grid>
            </>
          </FormProvider>
        );
      default:
        return null;
    }
  };

  const keys = Object.keys(sessionDetailsData);
  let hasSessionData: any = {};
  for (let i = 0; i < keys.length; i++) {
    const date = keys[i];
    const sessions = sessionDetailsData[date].sessions;

    for (let j = 0; j < sessions.length; j++) {
      const sessionData = sessions[j];
      console.log('sessions12', sessionData);

      if (hasSessionData.hasOwnProperty(date)) {
        if (sessionData.Id) {
          hasSessionData[date].push(sessionData);
        }
      } else {
        if (sessionData.Id) {
          hasSessionData[date] = [sessionData];
        } else {
          hasSessionData[date] = [];
        }
      }
    }
  }
  const hasSomeEmptySessions = Object.values(hasSessionData).some((items: any) => {
    return items.length === 0;
  });

  const [isFormUnchanged, setIsFormUnchanged] = useState(true);

  useEffect(() => {
    setIsFormUnchanged(!isDirty);
  }, [isDirty]);

  const confirmNavigation = () => {
    reset(); // Reset the form to clear the dirty state
    setIsFormUnchanged(true);

    dispatch({
      type: 'removeAllFiles',
      value: {},
    });
  };

  return (
    <>
      {loading && <KenLoader />}
      <Paper
        component={'form'}
        onSubmit={handleSubmit((data, e: any) => {
          if (e.nativeEvent.submitter.name === 'totalSubmit') {
            createEvent(data);
          }
        })}
        className={`${classes.cardContainerForm} scrollbar-cusgray`}
      >
        <Grid item container xs={12} md={12}>
          <Grid item lg={isWithing1400 ? 1.5 : 2} md={0} />
          <Grid
            item
            lg={isWithing1400 ? 9 : 8}
            md={12}
            sx={{
              '@media (min-width: 1280px) and (max-width: 1300px)': {
                height: '63vh !important',
              },
            }}
            className="scrollbar-cusgray"
          >
            <FormProvider {...method}>
              <Box component={'div'} style={{ background: KenColors.ClientGrey2, padding: '6px 0px', borderRadius: '8px' }}>
                <Stepper activeStep={activeStep}>
                  {steps.map((label, index) => {
                    const isStepCompleted = activeStep > index;
                    const isStepActive = activeStep === index;
                    const isStepDisabled = index > activeStep;

                    return (
                      <Step key={label} style={{ padding: '12px' }}>
                        <StepLabel
                          StepIconComponent={(props: StepIconProps) => {
                            if (isStepDisabled) {
                              return <CircleIcon style={{ color: 'grey' }} />;
                            } else if (isStepCompleted) {
                              return <CheckCircleIcon style={{ color: 'green' }} />;
                            } else if (isStepActive) {
                              return (
                                <div
                                  style={{
                                    width: '24px',
                                    height: '24px',
                                    borderRadius: '50%',
                                    backgroundColor: KenColors.ClientBlue6,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                  }}
                                >
                                  {index + 1}
                                </div>
                              );
                            }
                            return <CircleIcon />;
                          }}
                          StepIconProps={{
                            sx: {
                              color: isStepCompleted ? 'green !important' : isStepActive ? `${KenColors.ClientBlue6} !important` : 'gray !important',
                              backgroundColor: isStepActive || isStepCompleted ? 'transparent' : 'inherit',
                              borderRadius: '50%',
                            },
                          }}
                          className={classes.stepLabel}
                        >
                          {ismobile ? <>{isStepActive ? label : ''}</> : label}
                        </StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
              </Box>
              <Box component={'div'} className="d-flex gap-3 align-items-center" marginTop={'15px'} marginBottom={'15px'}>
                <LinearProgress value={((activeStep + 1) / 5) * 100} color="success" sx={{ background: KenColors.ClientStepperProgress, height: '4px', width: '100%' }} variant="determinate" />
                <Typography fontSize={'12px'} fontWeight={'500'} color={KenColors.ClientStepperProgressText} className={classes.stepProgress}>
                  Step {`${activeStep + 1} out of 5`}
                </Typography>
              </Box>
              <Box component={'div'} className="scrollbar-hide" padding={'0px'} height={isWithing1400 ? '53vh' : '58vh'} sx={{ overflow: 'auto' }}>
                {StepperContent(activeStep)}
              </Box>
            </FormProvider>
          </Grid>

          <Grid item lg={isWithing1400 ? 1.5 : 2} md={0} />
        </Grid>

        <div className="d-flex justify-content-between align-items-center" style={{ borderTop: `1px solid ${KenColors.ClientDivider}`, paddingTop: '15px' }}>
          {activeStep === steps.length - 1 ? (
            <AppButton
              size="small"
              type="reset"
              variant="text"
              others={{ fontSize: '12px', fontWeight: '500', color: KenColors.ClientBlack2, height: '36px', paddingTop: ismobile ? '16px' : '0px' }}
              disabled={activeStep === 0}
              onClick={() => {
                // handleCancel();
                navigate.push(routes.events);
              }}
            >
              Skip & submit request
            </AppButton>
          ) : (
            <div />
          )}

          <div className={classes.formFooter}>
            <AppButton
              size="small"
              type="reset"
              variant="text"
              others={{ fontSize: '12px', fontWeight: '500', color: KenColors.ClientBlack2, height: '36px', padding: ismobile ? '10px' : '12px' }}
              // disabled={activeStep === 0}
              onClick={() => {
                if (activeStep === 0) {
                  navigate.push(routes.events);
                } else {
                  handleCancel();
                }
              }}
            >
              {activeStep === 0 ? 'Cancel' : 'Previous step'}
            </AppButton>
            {activeStep === 4 ? (
              <AppButton
                name="triggerFeedback"
                id="triggerFeedback"
                aria-label="triggerFeedback"
                size="small"
                type="button"
                variant="contained"
                others={{ fontSize: '12px', color: '#5B4200', fontWeight: '500', padding: ismobile ? '20px' : '12px', borderRadius: '8px', height: '36px' }}
                onClick={() => {
                  handleTriggerFeedbackForm();
                }}
              >
                Trigger feedback form
              </AppButton>
            ) : (
              <AppButton
                name="totalSubmit"
                id="totalSubmit"
                aria-label="totalSubmit"
                size="small"
                type={activeStep === 2 || activeStep === 3 ? 'button' : 'submit'}
                variant="contained"
                others={{ fontSize: '12px', fontWeight: '500', padding: '12px', borderRadius: '8px', height: '36px', color: '#5B4200' }}
                disabled={steps.length === activeStep || (activeStep == 2 && hasSomeEmptySessions)}
                onClick={() => {
                  if (activeStep === 2 || activeStep === 3) {
                    createEvent(getValues());
                  }
                }}
              >
                {activeStep === 2 ? 'Proceed to fee setup' : 'Save and proceed'}
              </AppButton>
            )}
          </div>
        </div>
      </Paper>

      <Prompt when={!isFormUnchanged} message="All your changes will be lost. If you navigate away, you will lose progress. Are you sure you want to continue?" />
    </>
  );
};
export default HostEvent;
